/**
 * rondo-web-forms
 *
 * Rondo Web Forms
 *
 * @author Jiri Hybek <jiri@hybek.cz>
 * @author Jiri Moc <jiri.moc@outlook.cz>
 * @license See LICENSE file distributed with this source code.
 */

import { Form } from "../shared/FormModel/FormModel";
import { SectionGroup } from "../shared/FormModel/elements/FormSectionGroup";
import { Section } from "../shared/FormModel/elements/FormSection";
import { Row } from "../shared/FormModel/elements/FormRow";
import { HTMLContent } from "../shared/FormModel/elements/FormHTMLContent";
import { FieldText } from "../shared/FormModel/elements/FormFieldText";
import { FieldLabel } from "../shared/FormModel/elements/FormFieldLabel";

export const form_formularProZamereni = Form({
    id: "formular-pro-zamereni",
    version: "2020-07-r1",
    title: "Formulář pro zaměření",
    icon: "ruler-square",
    showInMenu: true
}, [
    SectionGroup({}, [
        Section({
            id: "hlavicka-datum",
            title: "Záměr proveden"
        }, [
            Row({
                id: "zamer-proveden"
            }, [
                FieldLabel({
                    width: "1/3",
                    label: "Datum a čas"
                }),
                FieldText({
                    id: "zamer-proveden"
                }),
            ]),
        ]),
    ]),
    SectionGroup({}, [
        Section({
            id: "hlavicka-pracovnik",
            title: "Záměr provedl a zpracoval"
        }, [
            Row({
                id: "pracovnik-zameril"
            }, [
                FieldLabel({
                    width: "1/3",
                    label: "Zaměřující osoba"
                }),
                FieldText({
                    id: "pracovnik-zameril"
                }),
            ]),
            Row({
                id: "pracovnik-kontakt"
            }, [
                FieldLabel({
                    width: "1/3",
                    label: "Kontakt"
                }),
                FieldText({
                    id: "pracovnik-kontakt"
                }),
            ]),
            Row({
                id: "pracovnik-podpis"
            }, [
                FieldLabel({
                    width: "1/3",
                    label: "Podpis"
                }),
                FieldText({
                    id: "pracovnik-podpis"
                }),
            ]),
        ]),
    ]),
    SectionGroup({}, [
        Section({
            id: "hlavicka-zakaznik",
            title: "Protokol převzal"
        }, [
            Row({
                id: "zakaznik-jmeno"
            }, [
                FieldLabel({
                    width: "1/3",
                    label: "Zákazník"
                }),
                FieldText({
                    id: "zakaznik-jmeno"
                }),
            ]),
            Row({
                id: "zakaznik-adresa"
            }, [
                FieldLabel({
                    width: "1/3",
                    label: "Adresa"
                }),
                FieldText({
                    id: "zakaznik-adresa"
                }),
            ]),
            Row({
                id: "zakaznik-kontakt"
            }, [
                FieldLabel({
                    width: "1/3",
                    label: "Kontakt"
                }),
                FieldText({
                    id: "zakaznik-kontakt"
                }),
            ]),
            Row({
                id: "zakaznik-podpis"
            }, [
                FieldLabel({
                    width: "1/3",
                    label: "Podpis"
                }),
                FieldText({
                    id: "zakaznik-podpis"
                }),
            ]),
        ]),
    ]),
    SectionGroup({}, [
        Section({
            id: "body-zameru",
            title: "Body záměru"
        }, [
            Row({
                id: "adresa-realizace"
            }, [
                FieldLabel({
                    width: "1/3",
                    label: "Adresa realizace"
                }),
                FieldText({
                    id: "adresa-realizace"
                }),
            ]),
            Row({
                id: "patro"
            }, [
                FieldLabel({
                    width: "1/3",
                    label: "Patro"
                }),
                FieldText({
                    id: "patro"
                }),
            ]),
            Row({
                id: "zmerit-veci"
            }, [
                FieldLabel({
                    width: "1/3",
                    label: "Změřit průchody (popř. výtah), prostory na chodbě, ..."
                }),
                FieldText({
                    id: "zmerit-veci"
                }),
            ]),
            Row({
                id: "zajistit-parkovani"
            }, [
                FieldLabel({
                    width: "1/3",
                    label: "Zjistit parkování velkého auta (popř. zajistit)"
                }),
                FieldText({
                    id: "zajistit-parkovani"
                }),
            ]),
            Row({
                id: "nerovnost-zdi"
            }, [
                FieldLabel({
                    width: "1/3",
                    label: "Nerovnost zdí (křivost)"
                }),
                FieldText({
                    id: "nerovnost-zdi"
                }),
            ]),
            Row({
                id: "zamerit-mistnosti"
            }, [
                FieldLabel({
                    width: "1/3",
                    label: "Zaměřit místnost (šířka, výška, délka, výklenky, průchody)"
                }),
                FieldText({
                    id: "zamerit-mistnosti"
                }),
            ]),
            Row({
                id: "zamerit-instalace"
            }, [
                FieldLabel({
                    width: "1/3",
                    label: "Zaměřit elektro, vodu, odtah, okna, dveře, topení, otvory, dveře"
                }),
                FieldText({
                    id: "zamerit-instalace"
                }),
            ]),
            Row({
                id: "zapsat-materialy"
            }, [
                FieldLabel({
                    width: "1/3",
                    label: "Zapsat materiál, podlaha, zdi, strop"
                }),
                FieldText({
                    id: "zapsat-materialy"
                }),
            ]),
            Row({
                id: "pripadne-zmeny"
            }, [
                FieldLabel({
                    width: "1/3",
                    label: "Případné změny elektra, stavební, vody, ..."
                }),
                FieldText({
                    id: "pripadne-zmeny"
                }),
            ]),
            Row({
                id: "vse-nafotit"
            }, [
                FieldLabel({
                    width: "1/3",
                    label: "Vše nafotit (vstup, místnost, rozvody, ...)"
                }),
                FieldText({
                    id: "vse-nafotit"
                }),
            ]),
            Row({
                id: "zajistit-volny-pruchod"
            }, [
                FieldLabel({
                    width: "1/3",
                    label: "Zjistit zda do prostoru nábytku nezasahují dveře, okna, ..."
                }),
                FieldText({
                    id: "zajistit-volny-pruchod"
                }),
            ]),
            Row({
                id: "zajistit-teplotu"
            }, [
                FieldLabel({
                    width: "1/3",
                    label: "Zajistit min. 15°C v den montáže a osvětlení"
                }),
                FieldText({
                    id: "zajistit-teplotu"
                }),
            ]),
            Row({
                id: "km-od-prodejny"
            }, [
                FieldLabel({
                    width: "1/3",
                    label: "KM od prodejny"
                }),
                FieldText({
                    id: "km-od-prodejny"
                }),
            ]),
        ]),
    ]),
]);